/**
 *
 */
export class VectorSortHelper {
    /**
     * A stable sort for Vectors. Stable sorting algorithms maintain the relative order of records with equal keys. Vector's built in sort algorithm is not stable, so this is a good alternative.<br/><br/>
     * The sort alogrithm used in this method is Insertion sort, which is very performant for small size vectors (n %lt; 10).
     *
     * @param     vector              Input vector - use the Vector class only! This method implements Object instead of Vector&lt;T&gt; because of AS3 limitations.
     * @param     compareFunction     The specified method must take two arguments of the base type (T) of the Vector and return a Number:<br/><br/>
     *                                <code>function compare(x:T, y:T):Number {}</code><br />
     *                                The logic of the compareFunction function is that, given two elements x and y, the function returns one of the following three values:<br/><br/>
     *                                <ul>
     *                                  <li>a negative number, if x should appear before y in the sorted sequence</li>
     *                                  <li>0, if x equals y</li>
     *                                  <li>a positive number, if x should appear after y in the sorted sequence</li>
     *                                </ul>
     * @return                        Object — The Vector, with elements in the new order.
     * @author                        Malte Quenstedt
     */
    public static sort(vector: any[], compareFunction: Function): any[] {
        // ascending order sorting
        for (let i: number = 1; i < vector.length; i++) {
            let value: Object = vector[i];
            let k: number = i - 1;

            // shift element left as long as comparing element is bigger
            while (k >= 0 && compareFunction(vector[k], value) == 1) {
                vector[k + 1] = vector[k];
                k--;
            }
            vector[k + 1] = value;
        }

        return vector;
    }
}
